'use client';
import { cn } from '~/lib/utils';
import { useState } from 'react';
import Image from 'next/image';
import { JobChangeBanner } from '~/components/banner/job-change-banner';

export const SPHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuText, setMenuText] = useState('メニュー');
  const toggle = () => {
    setIsOpen(!isOpen);
    setMenuText(isOpen ? 'メニュー' : '閉じる');
  };
  return (
    <>
      <div className="l-header -base md:hidden">
        <div className="l-header-container">
          <div className="u-flex -justify-between u-gap10 l-header__icon-wrapper">
            <a
              href="/entry_member?ref=top-sp-header"
              className="l-header__icon"
            >
              <Image
                alt="会員登録アイコン"
                src="/nextjs/images/icons/ic_registration.png"
                width="20"
                height="20"
                className="u-ml4"
              />
              <div className="l-header__icon-text">会員登録</div>
            </a>
            <a href="/login?ref=top-sp-header" className="l-header__icon">
              <Image
                alt="ログインアイコン"
                src="/nextjs/images/icons/ic_login.png"
                width="20"
                height="20"
              />
              <div className="l-header__icon-text">ログイン</div>
            </a>
          </div>
          <div className="l-header__image -center">
            <a href="/">
              <Image
                alt="ロゴ"
                src="/nextjs/images/logo/logo.webp"
                width="160"
                height="40"
              />
            </a>
          </div>
          <div
            id="js-hamburger-bg"
            className={cn('l-header__sp-hamburger u-w50', isOpen && '-open')}
          ></div>
          <div className="u-flex -items-center u-mr3 u-gap15">
            <a href="/jobs?ref=top-sp-header" className="l-header__icon">
              <Image
                alt="虫眼鏡アイコン"
                src="/nextjs/images/icons/ic_magnifying-glass.svg"
                width="20"
                height="20"
              />
              <div className="l-header__icon-text">求人検索</div>
            </a>
            <div className="c-hamburger__icon-wrapper" onClick={() => toggle()}>
              <div className={`c-hamburger__icon ${isOpen && '-open'}`}></div>
              <div className="l-header__icon-text">{menuText}</div>
            </div>
          </div>
        </div>
      </div>
      <SPDrawer isOpen={isOpen} />
    </>
  );
};

type SPDrawerProps = {
  isOpen: Boolean;
};
const SPDrawer = (props: SPDrawerProps) => {
  return (
    <div className="c-hamburger">
      <nav className={`c-hamburger__menu ${props.isOpen && '-open'}`}>
        <div className="u-pt10 u-px20 u-w-full">
          <div className="u-flex -justify-between">
            <a
              href="/entry_member?ref=sp-menu-cta"
              className="c-button -green -arrow-right -flex-twin-btn u-flex -justify-center"
            >
              <div className="u-mr10">
                <span className="c-label -bg-white -hamburger-entry-sp u-px4 u-py2 u-mr4">
                  無料
                </span>
                <span>会員登録</span>
              </div>
            </a>
            <a
              href="/login?ref=sp-menu-login"
              className="c-button -fullwhite -border-lightgray -no-shadow -arrow-right -gray-arrow -flex-twin-btn -ml2"
            >
              <p className="u-mr10 u-color-gray">ログイン</p>
            </a>
          </div>
          <div className="c-hamburger__item -border-with-radius u-bg-white u-p1 u-mt10">
            <a
              href="/inquiry_ep?ref=sp-menu-inquiry"
              className="c-hamburger__link u-py10 -arrow-right"
            >
              <Image
                alt="ビルアイコン"
                src="/nextjs/images/icons/ic_building.png"
                width="18"
                height="18"
              />
              <p className="u-fs12 u-ml11">採用のご担当者様へ</p>
            </a>
          </div>
          <div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1 u-mt10">
              <a
                href="/favorites?ref=sp-menu-favorites"
                className="c-hamburger__link u-py10 -arrow-right"
              >
                <Image
                  alt="お気に入りアイコン"
                  src="/nextjs/images/icons/ic_heart_outline_green.svg"
                  width="18"
                  height="18"
                  className="h-[18px]"
                />
                <p className="u-fs12 u-ml11">お気に入り</p>
              </a>
            </div>
            <div
              className={cn('c-hamburger__item -list-border u-bg-white u-p1')}
            >
              <a
                href="/histories"
                className="c-hamburger__link u-py10 -arrow-right"
              >
                <Image
                  alt="時計アイコン"
                  src="/nextjs/images/icons/ic_clock_outline_green.png"
                  width="18"
                  height="18"
                />
                <p className="u-fs12 u-ml11">閲覧履歴</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/entry_member?ref=sp-menu-message"
                className="c-hamburger__link u-py10 -arrow-right"
              >
                <Image
                  alt="メールアイコン"
                  src="/nextjs/images/icons/ic_mail_2.png"
                  width="18"
                  height="18"
                />
                <p className="u-fs12 u-ml11">スカウトメッセージ</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/entry_member?ref=sp-menu-interview"
                className="c-hamburger__link u-py10 -arrow-right"
              >
                <Image
                  alt="面接日程アイコン"
                  src="/nextjs/images/icons/ic_calendar.png"
                  width="18"
                  height="18"
                />
                <p className="u-fs12 u-ml11">面接日程</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/entry_member?ref=sp-menu-resume"
                className="c-hamburger__link u-py10 -arrow-right"
              >
                <Image
                  alt="Web履歴書アイコン"
                  src="/nextjs/images/icons/ic_user.png"
                  width="18"
                  height="18"
                />
                <p className="u-fs12 u-ml11">Web履歴書</p>
              </a>
            </div>
            <div className="c-hamburger__item -list-border u-bg-white u-p1">
              <a
                href="/examdk?ref=sp-menu-exam"
                className="c-hamburger__link u-py10 -arrow-right"
              >
                <Image
                  alt="電気工事士試験問題アイコン"
                  src="/nextjs/images/icons/ic_exam.svg"
                  width="18"
                  height="18"
                />
                <p className="u-fs12 u-ml11">電気工事士試験問題</p>
              </a>
            </div>
          </div>
          <div className="u-mt16">
            <JobChangeBanner isClientMobile={true} refPrefix="menu" />
          </div>
        </div>
      </nav>
    </div>
  );
};
